(function() {
    // 注册组件
    SR.modules.extend('checkWords', checkWords);

    function checkWords(question, options) {
        var urlSearch = location.search && location.search.replace('?', '').replace(/[\?&]ask=([^&#]*)/ig, '');
        $.ajax({
            method: 'POST',
            timeout: 3000,
            url: '/checkwords',
            data:
                'ask=' +
                encodeURIComponent(question) + 
                '&' +
                urlSearch.replace('ask=', 'oask=')
        }).done(function(data) {
            if (data.ret === -1) {
                SR.component.toast.show({msg: '您输入的问题包含敏感词'});
            } else {
                options.hasCheckedWords = true;
                window.ask(question, options);
            }
        }).fail(function() {
            SR.component.toast.show({msg: '网络错误，请重新发送'});
        });
    }
})();